"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: none;\n\n  @media print, screen and (min-width: ", "px) {\n    display: block;\n    padding: 0 25px;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    padding: 0 50px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ProgressBar = _styledComponents.default.div(_templateObject(), _Constant.Width.MD, _Constant.Width.LG);

var SidebarProgressBar = function SidebarProgressBar(props) {
  return /*#__PURE__*/_react.default.createElement(ProgressBar, props);
};

SidebarProgressBar.propTypes = {
  mediaMinWidth: _propTypes.default.string,
  mediaMinHeight: _propTypes.default.string
};
SidebarProgressBar.defaultProps = {
  mediaMinWidth: "".concat(_Constant.Width.MD, "px"),
  mediaMinHeight: '675px'
};
var _default = SidebarProgressBar;
exports.default = _default;